import { render } from "./NapDetail.vue?vue&type=template&id=3e50afb6&ts=true"
import script from "./NapDetail.vue?vue&type=script&lang=ts"
export * from "./NapDetail.vue?vue&type=script&lang=ts"

import "./NapDetail.vue?vue&type=style&index=0&id=3e50afb6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__